export default class LoginTrigger {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init() {
        this.viewMetaData = window.viewMetaData;

        if (typeof this.viewMetaData !== 'object') {
            return false;
        }

        this.deviceOutput = this.getDeviceOutput();
        this.isLoggedIn = this.getUserIsLoggedIn();
        this.ssoProduct = this.getSSOProduct();
        this.ssoEnvironment = this.getSSOEnvironment();

        if (this.deviceOutput !== 'tabletapp' && this.deviceOutput !== 'app') {
            this.configureUnifiedLogin(this.deviceOutput);
            this.listenUnifiedLoginEvent();
        }

        this.url = new URL(location.href);
        this.refUrl = this.url.searchParams.get('ref');
        if (this.refUrl !== null && !this.isLoggedIn) {
            this.openLoginLayer();
        }

        this.elements = document.querySelectorAll('[data-login-trigger]');
        if (this.elements.length > 0) {
            this.bindEvents();
        }
    }

    getDeviceOutput() {
        return typeof this.viewMetaData.deviceOutput !== 'undefined' ?
            this.viewMetaData.deviceOutput : 'desktop';
    }

    getSSOProduct() {
        return typeof this.viewMetaData.ssoProduct !== 'undefined' ?
            this.viewMetaData.ssoProduct : '';
    }

    getSSOEnvironment() {
        return typeof this.viewMetaData.ssoEnvironment !== 'undefined' ?
            this.viewMetaData.ssoEnvironment : 'prod';
    }

    getUserIsLoggedIn() {
        return typeof this.viewMetaData.userIsLoggedIn !== 'undefined' ?
            this.viewMetaData.userIsLoggedIn : undefined;
    }

    openAppLogin() {
        if (this.refUrl !== null) {
            this.appRedirectUrl = `c24-app-login://${this.refUrl.split('https://').pop()}`;
        } else {
            this.appRedirectUrl = `c24-app-login://${location.hostname}${location.pathname}${location.search}`;
        }
        this.redirect(this.appRedirectUrl);
    }

    openLoginLayer() {
        if (this.deviceOutput === 'tabletapp' || this.deviceOutput === 'app') {
            this.openAppLogin();
        } else {
            this.triggerUnifiedLogin();
        }
    }

    bindEvents() {
        this.elements.forEach(element => (
            element.addEventListener('click', () => this.openLoginLayer())
        ));
    }

    triggerUnifiedLogin() {
        window.Check24.uliloginlayer.open();
    }

    configureUnifiedLogin(device) {
        if (window.Check24) {
            window.Check24.uliloginlayer.config.env = this.ssoEnvironment;
            window.Check24.uliloginlayer.init({
                'deviceoutput': device,
                'api_product': this.ssoProduct
            });
        }
    }

    redirect(href) {
        /* istanbul ignore next */
        window.location.href = href;
    }

    reload() {
        /* istanbul ignore next */
        window.location.reload();
    }

    handleLogin(loginType) {
        if (['register', 'login'].includes(loginType) && this.refUrl !== null) {
            this.redirect(this.refUrl);
        } else {
            this.reload();
        }
    }

    handleLoginPayload(payload) {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/konten/common/rest/unified-login/set-cookie.php', true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                this.handleLogin(payload.LOGINTYPE);
            }
        };
        if (payload.hasOwnProperty('SSO_SESSION')) {
            xhr.send(`c24session=${payload.SSO_SESSION}`);
        }
    }

    listenUnifiedLoginEvent() {
        window.addEventListener('uli-login-layer', (event) => {
            if (event.detail && event.detail.ul) {
                this.handleLoginPayload(event.detail.ul);
            }
        });
    }
}
